import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=bf8eccf6&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=bf8eccf6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8eccf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf8eccf6')) {
      api.createRecord('bf8eccf6', component.options)
    } else {
      api.reload('bf8eccf6', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=bf8eccf6&scoped=true", function () {
      api.rerender('bf8eccf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Shared/Partials/Footer.vue"
export default component.exports